<section class="bg-white rounded-t-xl shadow p-4 md:p-6">
  <p class="border-4 w-full border-black mb-4"></p>
  <p class="text-base sm:text-lg font-semibold text-gray-600">Tema da noite:</p>
  <h1 class="text-2xl sm:text-3xl md:text-5xl font-extrabold text-gray-900">{{ event.title }}</h1>

  <div class="mt-4 flex flex-col md:flex-row gap-6 md:gap-8 items-start md:items-center">
    <!-- Info: data + expositor + local -->
    <div class="w-full md:w-auto shrink-0 space-y-6">
      <div class="w-full max-w-[200px] h-[100px] sm:h-[120px] rounded-md bg-gray-200 shadow flex flex-col items-center justify-center">
        <div>
          <span class="text-[#E90128] text-3xl sm:text-[40px] font-bold leading-5 mr-1">{{ day() }}</span>
          <span class="text-[#E90128] text-3xl sm:text-[40px] font-bold uppercase tracking-wide">{{ month() }}</span>
        </div>
        <div class="font-bold text-lg sm:text-xl mt-2">{{ time() }}</div>
      </div>

      <div class="text-gray-900 space-y-4">
        <!-- Expositor -->
        <div>
          <div class="flex items-center gap-2 text-sm text-gray-600">
            <svg class="h-5 w-5 text-black shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 1a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3Z" />
              <path d="M19 10v1a7 7 0 1 1-14 0v-1" />
              <line x1="12" y1="19" x2="12" y2="23" />
              <line x1="8" y1="23" x2="16" y2="23" />
            </svg>
            <span>Expositor do tema:</span>
          </div>
          <span class="block mt-1 font-bold text-lg sm:text-xl">
            {{ event.speakers.length ? event.speakers[0].name : '—' }}
          </span>
        </div>

        <!-- Local -->
        <div>
          <div class="flex items-center gap-2 text-sm text-gray-600">
            <svg class="h-5 w-5 text-black shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 21s-6-5.686-6-10a6 6 0 1 1 12 0c0 4.314-6 10-6 10Z" />
              <circle cx="12" cy="11" r="2" />
            </svg>
            <span>Local:</span>
          </div>
          <a *ngIf="event.venue.mapUrl?.trim(); else venuePlain"
             [href]="event.venue.mapUrl!.trim()"
             target="_blank"
             rel="noopener noreferrer"
             class="block mt-1 font-bold text-lg sm:text-xl text-gray-900 hover:text-[#E90128] underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E90128] rounded">
            {{ event.venue.name }}
          </a>
          <ng-template #venuePlain>
            <span class="block mt-1 font-bold text-lg sm:text-xl">{{ event.venue.name }}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Carousel de imagens -->
    <div class="mt-2 md:mt-0 relative min-w-0 flex-1 w-full">
      <img
        [src]="slides()[carouselIndex]"
        [alt]="event.title"
        (click)="openLightbox()"
        class="w-full object-cover aspect-[16/9] max-h-[450px] rounded-md bg-gray-100 cursor-pointer hover:opacity-95 transition"
      />
      <ng-container *ngIf="slides().length > 1">
        <button
          type="button"
          (click)="prev()"
          aria-label="Imagem anterior"
          class="absolute left-1 sm:left-[-40px] top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full w-9 h-9 hover:bg-black/70"
        >‹</button>
        <button
          type="button"
          (click)="next()"
          aria-label="Próxima imagem"
          class="absolute right-1 sm:right-[-40px] top-1/2 -translate-y-1/2 bg-black/50 text-white rounded-full w-9 h-9 hover:bg-black/70"
        >›</button>
      </ng-container>
    </div>
  </div>

  <!-- Lightbox do carrossel -->
  <div
    *ngIf="showLightbox"
    class="fixed inset-0 z-[200] flex items-center justify-center p-4 sm:p-8"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'Imagem ampliada: ' + event.title"
    (click)="closeLightbox()"
  >
    <div class="absolute inset-0 bg-black/85 backdrop-blur-[1px]" aria-hidden="true"></div>
    
    <button
      type="button"
      (click)="closeLightbox()"
      class="fixed top-4 right-4 z-30 flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-2xl leading-none text-white hover:bg-white/40 shadow-lg focus:outline-none"
      aria-label="Fechar"
    >
      ×
    </button>

    <div
      class="relative z-10 max-h-[90vh] w-full max-w-5xl overflow-y-auto rounded-lg shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <img
        [src]="slides()[carouselIndex]"
        [alt]="event.title"
        class="w-full h-auto block rounded-lg bg-gray-900"
      />
    </div>
  </div>
</section>
